import Registration from "./Registration"

const RegisterFlowContainer = () => {
  return <Registration />
}

export default RegisterFlowContainer

